import { autoinject, bindable, bindingMode,customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';


@customElement('aircraft-card')
@autoinject

export class AircraftCardCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.toView }) aircraftData: any = null;

    private timeRefresh: string = new Date().getTime() + '';

    async bind() {

    }
}
